import React from 'react';
import { Form } from 'antd';
import { isValidPhoneNumber } from 'react-phone-number-input';
import ReactPhoneInput from 'react-phone-input-2';

import 'react-phone-input-2/lib/style.css';
import './MobileNumber.css'

const MobileNumber = (props) => {
  const { name, label, required } = props

  return (
    <Form.Item
      name={name ?? 'name'}
      label={label ?? 'Mobile Number'}
      rules={[
        {
          required: (typeof required === 'boolean') ? required : true,
          message: 'Please enter mobile number',
        },
        {
          validator: async (_, value) => {
            if (value) {
              if (value.charAt(0) !== '+') {
                value = `+${value}`
              }
              if (isValidPhoneNumber(value)) {
                return Promise.resolve();
              }
              return Promise.reject(new Error('Please enter a valid mobile number'));
            }
          },
        },
      ]}
    >
      <ReactPhoneInput
        country='us'
        enableSearch={true}
        disableAreaCodes={true}
        countryCodeEditable={false}
      />
    </Form.Item>
  )
}

export default MobileNumber;